import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

function EmployeeQueryForm(props) {


    return(
        <Box className={props.isMobile ? "mobile-box" : "desktop-box"} display="flex" flexDirection="column">
            <Box className={props.isMobile ? "mobile-box" : "desktop-box"} display="flex" flexDirection="column">
                <Box display="flex">
                    <FormControl sx={{minWidth:"300px", ml:"20px"}}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Start Date"
                                name='orderStartDate'
                                onChange={(e) => props.setStartDate(e)}
                                value={props.startDate ? props.startDate : null}
                                renderInput={(params) => <TextField {...params} />}
                                clearable={true}
                            />
                        </LocalizationProvider>
                    </FormControl>
                    <FormControl sx={{minWidth:"300px", ml:"20px"}}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="End Date"
                                name='orderEndDate'
                                onChange={(e) => props.setEndDate(e)}
                                value={props.endDate ? props.endDate : null}
                                renderInput={(params) => <TextField {...params} />}
                                clearable={true}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Box>
                <Box className={props.isMobile ? "mobile-box" : "desktop-box"} display="flex" sx={{mt:"20px"}}>
                <FormControl sx={{minWidth:"300px", ml:"20px", mr:"20px"}}>
                        <InputLabel id="warehouse_label">Warehouse</InputLabel>
                        <Select
                            value={props.warehouse}
                            name='warehouse'   
                            label="Warehouse"        
                            onChange={(e) => props.updateWarehouse(e.target.value)}
                            defaultValue={""}
                        >
                            <MenuItem value="KY">Kentucky</MenuItem>
                            <MenuItem value="PA">Pennsylvania</MenuItem>
                            <MenuItem value="TX">Texas</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl sx={{minWidth:"300px"}}>

                        <InputLabel id="employee_label">Employee</InputLabel>
                        <Select
                            value={props.id}
                            name='employee'   
                            label="Employee"        
                            onChange={props.setId}
                            multiple
                            defaultValue={""}
                        >
                        {props.ids ? props.ids.map((obj,index) => {
                            return(<MenuItem key={index} value={obj.worker_id}>{obj.worker_id} | {obj.worker_name} ({obj.warehouse})</MenuItem>)
                        }) : null}
                        </Select>
                    </FormControl>
                </Box>
            </Box>
            <Box className={props.isMobile ? "mobile-box" : "desktop-box"} display="flex" sx={{mt:"20px", ml:"375px"}}>
                <Button onClick={()=>props.clear()} variant="contained" color="info" size="large">Clear</Button>
                <Button onClick={()=>props.search()} variant="contained" color="success" size="large" sx={{ml:"40px"}} disabled={!props.startDate || !props.warehouse || !props.endDate}>Search</Button>
            </Box>
            
        </Box>
    )
}

export default EmployeeQueryForm;